import React from 'react';
import {useFormContext} from 'react-hook-form';
import FormCheckbox from './FormCheckbox';

const FormCheckboxGroup = ({name, options, helpMessage, errorMessage, validate}) => {
  const {formState: {errors}} = useFormContext();

  return (
    <div className="mb-3">
      {options.map((opt) => (
        <div key={opt.value}>
          <FormCheckbox
            name={name}
            label={opt.label}
            value={opt.value}
            validate={validate}
          />
        </div>
      ))}

      {helpMessage && !errors[name] && (
        <small className="form-text text-muted">{helpMessage}</small>
      )}
      {errors[name] && (
        <small className="form-text text-danger">
          {errorMessage || errors[name]?.message}
        </small>
      )}
    </div>
  );
};

export default FormCheckboxGroup;
